import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getGoalCategories = createAsyncThunk(
  'goals/getGoalCategories',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/goal_categories`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateCategory = createAsyncThunk(
  // action type string
  'goals/updateGoalCategory',
  // callback function
  async ({ goalCategory, goalCategoryId, userId }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.put(
        `/goal_categories/${goalCategoryId}`,
        {
          goal_category: goalCategory,
          goal_category_id: goalCategoryId,
          user_id: userId,
        }
      );
      return result;
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const addGoalItem = createAsyncThunk(
  // action type string
  'goals/addGoalItem',
  // callback function
  async ({ goalItem, goalCategoryId, userId }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.post('goals', {
        text: goalItem,
        goal_category_id: goalCategoryId,
        user_id: userId,
        deleted: 0,
      });
      return result;
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);
export const getGoalItem = createAsyncThunk(
  // action type string
  'goals/getGoalItem',
  // callback function
  async ({ goalId, goalCategoryId }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.get(`/goals/${goalId}`);

      return {
        ...result.data,
        goalCategoryId,
      };
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const editGoalItem = createAsyncThunk(
  // action type string
  'goals/editGoalItem',
  // callback function
  async ({ goalItem, goalCategoryId, goalId, goalStatus, goal }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.put(`/goals/${goalId}`, {
        text: goalItem,
        goal_category_id: goalCategoryId,
        status: goalStatus,
        deleted: 0,
      });
      return result;
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);
export const patchGoalItem = createAsyncThunk(
  // action type string
  'goals/patchGoalItem',
  // callback function
  async ({ goalId, goal }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.patch(`/goals/${goalId}`, goal);
      return result;
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const deleteGoalItem = createAsyncThunk(
  // action type string
  'goals/deleteGoalItem',
  // callback function
  async ({ goalId }, thunkApi) => {
    try {
      // make request to backend
      const result = await securedAxiosInstance.delete(`/goals/${goalId}`);
      return result;
    } catch (error) {
      console.log(error);
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return thunkApi.rejectWithValue(error.response.data.message);
      } else {
        return thunkApi.rejectWithValue(error.message);
      }
    }
  }
);

export const selectBoxTemplate = createAsyncThunk(
  'boxTemplate/selectBoxTemplate',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(
        `/four_boxes_templates/${id}/select`
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
